angular.module('leanlaw').factory('originationInfoDefination', ['$http', 'leanLawAuth', function ($http, leanLawAuth) {
  const cancel = params => {
    // no need to cancel now. It loads only once.
  };
  const load = ({
    me,
    query
  }) => {
    const path = `${leanLawAuth.domain}/v1/matters/origination`;
    query.originatorId = me.id;
    query.startDate = null;
    query.endDate = null;
    query.billedState = null;
    query.scope = null;
    return $http.get(path, {
      params: query
    }).then(({
      data
    }) => {
      return {
        rows: data.matters.map(i => ({
          values: {
            matter: {
              value: i.label
            },
            client: {
              value: i.client?.label
            },
            percentage: {
              value: i.originationPercentage
            },
            stepDownStartDate: {
              value: i.originationStepDownStartDate
            },
            stepDownDuration: {
              value: i.originationStepDownPeriodInMonths
            }
          }
        }))
      };
    });
  };
  const structure = ({
    me
  }) => {
    return {
      sort: 'percentage',
      label: `My Origination Info`,
      subrow: {
        label: undefined
      },
      totals: {
        rows: false
      },
      showFilters: {
        distribution: false,
        archivedStatus: true
      },
      columns: [{
        id: 'client',
        label: 'Client'
      }, {
        id: 'matter',
        label: 'Matter'
      }, {
        id: 'percentage',
        label: 'Percentage',
        filter: 'percentage',
        number: true
      }, {
        id: 'stepDownStartDate',
        label: 'Step-down Start Date',
        filter: 'dateStandard',
        number: true,
        show: () => me.company.settings?.report?.originationStepDownPeriodInMonths
      }, {
        id: 'stepDownDuration',
        label: 'Step-down Duration',
        filter: 'monthNoZero',
        number: true,
        show: () => me.company.settings?.report?.originationStepDownPeriodInMonths
      }]
    };
  };
  return {
    structure,
    cancel,
    load
  };
}]);